import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';
import { CompanyPermissionsCodename } from 'src/api';
import { requireCompanyPermission } from 'src/router/guards/requireCompanyPermission';

const { $gettext } = gettext;

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'settings',
    redirect: { name: 'basic-settings' },
  },
  {
    path: 'currently',
    alias: $gettext('obecne'),
    children: [
      {
        path: '',
        name: 'basic-settings',
        component: () => import('src/pages/settings/SettingsPage.vue'),
      },
    ],
  },
  {
    path: 'reservation',
    alias: $gettext('rezervace'),
    name: 'reservations',
    beforeEnter: requireCompanyPermission(
      CompanyPermissionsCodename.ONLINE_RESERVATIONS
    ),
    component: () => import('src/pages/settings/ReservationsPage.vue'),
  },
  {
    path: 'notifications',
    alias: $gettext('notifikace'),
    name: 'notifications',
    component: () => import('src/pages/settings/NotificationsPage.vue'),
  },
  {
    path: 'sharing',
    name: 'sharing',
    component: () => import('src/pages/settings/ConnectionsPage.vue'),
  },
  {
    path: 'company-data',
    alias: $gettext('firemni-udaje'),
    name: 'company-data',
    component: () => import('src/pages/settings/CompanyDataPage.vue'),
  },
  {
    path: 'payments',
    alias: $gettext('platby'),
    name: 'settings-payments',
    component: () =>
      import('src/pages/settings/PaymentGateConfigurationPage.vue'),
  },
  {
    path: 'calendar-colors',
    alias: $gettext('barvy-kalendare'),
    name: 'calendar-colors',
    beforeEnter: requireCompanyPermission(
      CompanyPermissionsCodename.ALLOW_CALENDAR
    ),
    component: () => import('src/pages/settings/CalendarColorsPage.vue'),
  },
  {
    // No beforeEnter: requireCompanyPermission only covers company-level feature
    // flags, and this is gated on a user permission. The tab is hidden without it
    // and every endpoint 403s, so a direct URL just shows an empty list.
    path: 'service-accounts',
    alias: $gettext('servisni-ucty'),
    children: [
      {
        path: '',
        name: 'service-accounts',
        component: () =>
          import('src/pages/settings/service-accounts/ServiceAccountsListPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('novy'),
        name: 'create-service-account',
        component: () =>
          import('src/pages/settings/service-accounts/ServiceAccountCreatePage.vue'),
      },
      {
        path: ':serviceAccountId',
        props: true,
        children: [
          {
            path: '',
            name: 'service-account-detail',
            props: true,
            component: () =>
              import('src/pages/settings/service-accounts/ServiceAccountDetailPage.vue'),
          },
          {
            path: 'edit',
            alias: $gettext('upravit'),
            name: 'update-service-account',
            props: true,
            component: () =>
              import('src/pages/settings/service-accounts/ServiceAccountUpdatePage.vue'),
          },
        ],
      },
    ],
  },
  // Legacy redirects
  {
    path: 'billing-information',
    alias: $gettext('fakturacni-udaje'),
    name: 'billing-data',
    redirect: { name: 'company-data' },
  },
  {
    path: 'contact-details',
    alias: $gettext('kontaktni-udaje'),
    name: 'contact-information',
    component: () => import('src/pages/settings/ContactInformationPage.vue'),
  },
  {
    path: 'email-configuration',
    name: 'email-configuration',
    redirect: { name: 'notifications' },
  },
  {
    path: 'payment-gates',
    name: 'payment-gate-configuration',
    redirect: { name: 'settings-payments' },
  },
  {
    path: 'reviews',
    redirect: { name: 'reviews-list' },
  },
];
